import { NAME as namespace } from './constants';
import { userReducer as reducer } from './reducer';
import { finishLoadingUser, invalidateUser, loadUser as loadUserAction, loadUserInvoicingData as loadUserInvoicingDataAction, logout, onFapiaoCancelled, updateUser } from './actions';
export var loadUser = loadUserAction;
export var loadUserInvoicingData = loadUserInvoicingDataAction;
export var actions = {
  finishLoadingUser: finishLoadingUser,
  invalidateUser: invalidateUser,
  loadUser: loadUser,
  loadUserInvoicingData: loadUserInvoicingData,
  logout: logout,
  updateUser: updateUser,
  onFapiaoCancelled: onFapiaoCancelled
};
export var user = {
  namespace: namespace,
  reducer: reducer
};